"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaybookTaskAction = exports.PlaybookTargetingCampaignReenrollmentType = exports.PlaybookTargetingAudience = exports.PlaybookStatus = exports.PlaybookReportType = exports.PlaybookActionActionType = exports.PlaybookActionGroupOutputType = void 0;
var PlaybookActionGroupOutputType;

(function (PlaybookActionGroupOutputType) {
  PlaybookActionGroupOutputType["NONE"] = "NONE";
  PlaybookActionGroupOutputType["QUESTION"] = "QUESTION";
  PlaybookActionGroupOutputType["GOAL"] = "GOAL";
  PlaybookActionGroupOutputType["END_CONVERSATION"] = "END_CONVERSATION";
})(PlaybookActionGroupOutputType = exports.PlaybookActionGroupOutputType || (exports.PlaybookActionGroupOutputType = {}));

var PlaybookActionActionType;

(function (PlaybookActionActionType) {
  PlaybookActionActionType["INTERACTION"] = "INTERACTION";
  PlaybookActionActionType["WELCOME_MESSAGE"] = "WELCOME_MESSAGE";
  PlaybookActionActionType["SLIDER"] = "SLIDER";
  PlaybookActionActionType["TAKEOVER"] = "TAKEOVER";
  PlaybookActionActionType["AUTOMATIC_EMAIL"] = "AUTOMATIC_EMAIL";
  PlaybookActionActionType["ONE_TIME_EMAIL"] = "ONE_TIME_EMAIL";
  PlaybookActionActionType["EMAIL_CAPTURE"] = "EMAIL_CAPTURE";
  PlaybookActionActionType["ONE_TIME_OUTBOUND_EMAIL"] = "ONE_TIME_OUTBOUND_EMAIL";
  PlaybookActionActionType["OUTBOUND_SEQUENCE"] = "OUTBOUND_SEQUENCE";
  PlaybookActionActionType["MARKETING_SEQUENCE"] = "MARKETING_SEQUENCE";
  PlaybookActionActionType["SIGNATURE"] = "SIGNATURE";
  PlaybookActionActionType["LANDING_PAGE"] = "LANDING_PAGE";
  PlaybookActionActionType["PERSONAL_GREETING"] = "PERSONAL_GREETING";
  PlaybookActionActionType["VIDEO_BOT"] = "VIDEO_BOT";
  PlaybookActionActionType["VIDEO_BOT_MEETING"] = "VIDEO_BOT_MEETING";
})(PlaybookActionActionType = exports.PlaybookActionActionType || (exports.PlaybookActionActionType = {}));

var PlaybookReportType;

(function (PlaybookReportType) {
  PlaybookReportType["BOOK_MORE_MEETINGS"] = "BOOK_MORE_MEETINGS";
  PlaybookReportType["MORE_QUALIFIED_CONVERSATIONS"] = "MORE_QUALIFIED_CONVERSATIONS";
  PlaybookReportType["MORE_SALES_CONVERSATIONS"] = "MORE_SALES_CONVERSATIONS";
  PlaybookReportType["DRIVE_TRAFFIC_TARGETED_MESSAGE"] = "DRIVE_TRAFFIC_TARGETED_MESSAGE";
  PlaybookReportType["PROMOTION_FULL_SCREEN_TAKEOVER"] = "PROMOTION_FULL_SCREEN_TAKEOVER";
  PlaybookReportType["SEND_AN_AUTOMATED_EMAIL"] = "SEND_AN_AUTOMATED_EMAIL";
  PlaybookReportType["TALK_TO_YOUR_OUTBOUND_PROSPECTS"] = "TALK_TO_YOUR_OUTBOUND_PROSPECTS";
  PlaybookReportType["SEND_A_ONETIME_EMAIL"] = "SEND_A_ONETIME_EMAIL";
  PlaybookReportType["BUILD_A_SUBSCRIBER_LIST"] = "BUILD_A_SUBSCRIBER_LIST";
  PlaybookReportType["EMPTY_LEADBOT"] = "EMPTY_LEADBOT";
  PlaybookReportType["EMPTY_SLIDER"] = "EMPTY_SLIDER";
  PlaybookReportType["EMPTY_WELCOME_MESSAGE"] = "EMPTY_WELCOME_MESSAGE";
  PlaybookReportType["EMPTY_TAKEOVER"] = "EMPTY_TAKEOVER";
  PlaybookReportType["NPS_BOT"] = "NPS_BOT";
  PlaybookReportType["SEND_A_ONETIME_OUTBOUND_EMAIL"] = "SEND_A_ONETIME_OUTBOUND_EMAIL";
  PlaybookReportType["ABM"] = "ABM";
  PlaybookReportType["OUTBOUND_SEQUENCE"] = "OUTBOUND_SEQUENCE";
  PlaybookReportType["MARKETING_SEQUENCE"] = "MARKETING_SEQUENCE";
  PlaybookReportType["MARKETING_ONE_TIME_SEQUENCE"] = "MARKETING_ONE_TIME_SEQUENCE";
  PlaybookReportType["BLOG_NURTURE"] = "BLOG_NURTURE";
  PlaybookReportType["NEW_BLOG_CONTENT"] = "NEW_BLOG_CONTENT";
  PlaybookReportType["NEWSLETTER"] = "NEWSLETTER";
  PlaybookReportType["PRODUCT_ANNOUNCEMENT"] = "PRODUCT_ANNOUNCEMENT";
  PlaybookReportType["ABANDONED_BOOK_A_MEETING"] = "ABANDONED_BOOK_A_MEETING";
  PlaybookReportType["SIGNATURE"] = "SIGNATURE";
  PlaybookReportType["LANDING_PAGE_LEADBOT"] = "LANDING_PAGE_LEADBOT";
  PlaybookReportType["VSB_DEFAULT_PLAYBOOK"] = "VSB_DEFAULT_PLAYBOOK";
  PlaybookReportType["CONVERSATION_STARTER_BOT"] = "CONVERSATION_STARTER_BOT";
  PlaybookReportType["RETARGETING_BOT"] = "RETARGETING_BOT";
  PlaybookReportType["PRICING_PAGE_BOT"] = "PRICING_PAGE_BOT";
  PlaybookReportType["SECOND_NET_BOT"] = "SECOND_NET_BOT";
  PlaybookReportType["ABM_HOMEPAGE_BOT"] = "ABM_HOMEPAGE_BOT";
  PlaybookReportType["PAID_TRAFFIC_BOT"] = "PAID_TRAFFIC_BOT";
  PlaybookReportType["PERSONAL_GREETING"] = "PERSONAL_GREETING";
  PlaybookReportType["FORM_REPLACER_CLP"] = "FORM_REPLACER_CLP";
  PlaybookReportType["CONVO_CONTENT_CLP"] = "CONVO_CONTENT_CLP";
  PlaybookReportType["EMAIL_BOTS_V2"] = "EMAIL_BOTS_V2";
  PlaybookReportType["ENTERPRISE_BOT"] = "ENTERPRISE_BOT";
  PlaybookReportType["VIDEO_BOT"] = "VIDEO_BOT";
  PlaybookReportType["VIDEO_BOT_MEETING"] = "VIDEO_BOT_MEETING";
  PlaybookReportType["FORM_SUBMISSION_FAST_LANE"] = "FORM_SUBMISSION_FAST_LANE";
  PlaybookReportType["AI_TOPICS"] = "AI_TOPICS";
  PlaybookReportType["ENGAGE_ALL_BOT"] = "ENGAGE_ALL_BOT";
  PlaybookReportType["SKIP_THE_FORM_BOT"] = "SKIP_THE_FORM_BOT";
  PlaybookReportType["VISITOR_RETARGETING_BOT"] = "VISITOR_RETARGETING_BOT";
  PlaybookReportType["BLOG_BOT"] = "BLOG_BOT";
  PlaybookReportType["PAID_AD_CONVERTER_BOT"] = "PAID_AD_CONVERTER_BOT";
  PlaybookReportType["TARGET_ACCOUNTS_BOT"] = "TARGET_ACCOUNTS_BOT";
  PlaybookReportType["MEETING_BOOKING_BOT"] = "MEETING_BOOKING_BOT";
})(PlaybookReportType = exports.PlaybookReportType || (exports.PlaybookReportType = {}));

var PlaybookStatus;

(function (PlaybookStatus) {
  PlaybookStatus["ENABLED"] = "ENABLED";
  PlaybookStatus["DISABLED"] = "DISABLED";
  PlaybookStatus["ARCHIVED"] = "ARCHIVED";
  PlaybookStatus["SENT"] = "SENT";
  PlaybookStatus["DELETED"] = "DELETED";
  PlaybookStatus["SCHEDULED"] = "SCHEDULED";
})(PlaybookStatus = exports.PlaybookStatus || (exports.PlaybookStatus = {}));

var PlaybookTargetingAudience;

(function (PlaybookTargetingAudience) {
  PlaybookTargetingAudience["EVERYONE"] = "EVERYONE";
  PlaybookTargetingAudience["VISITORS"] = "VISITORS";
  PlaybookTargetingAudience["USERS"] = "USERS";
  PlaybookTargetingAudience["SEGMENT"] = "SEGMENT";
  PlaybookTargetingAudience["NONE"] = "NONE";
  PlaybookTargetingAudience["PREVIOUS"] = "PREVIOUS";
  PlaybookTargetingAudience["INTERACTED_SESSION"] = "INTERACTED_SESSION";
})(PlaybookTargetingAudience = exports.PlaybookTargetingAudience || (exports.PlaybookTargetingAudience = {}));

var PlaybookTargetingCampaignReenrollmentType;

(function (PlaybookTargetingCampaignReenrollmentType) {
  PlaybookTargetingCampaignReenrollmentType["ONCE"] = "ONCE";
  PlaybookTargetingCampaignReenrollmentType["ONCE_PER_SESSION"] = "ONCE_PER_SESSION";
  PlaybookTargetingCampaignReenrollmentType["ALWAYS"] = "ALWAYS";
})(PlaybookTargetingCampaignReenrollmentType = exports.PlaybookTargetingCampaignReenrollmentType || (exports.PlaybookTargetingCampaignReenrollmentType = {}));

var PlaybookTaskAction;

(function (PlaybookTaskAction) {
  PlaybookTaskAction["ENABLE"] = "ENABLE";
  PlaybookTaskAction["DISABLE"] = "DISABLE";
})(PlaybookTaskAction = exports.PlaybookTaskAction || (exports.PlaybookTaskAction = {}));